import {Fault, ViewFault} from '@docma-mm-core/fault/fault';
import {ChangeStatusEnum} from '@docma-mm-core/model/change-state/change-status.enum';
import {SyncStatusEnum} from '@docma-mm-core/model/sync-state/sync-status.enum';
import {ActivityPatchModeEnum} from '@docma-mm-core/activity/activity-patch-mode.enum';
import {LoadStatusEnum} from '@docma-mm-core/model/load-state/load-state.enum';
import {SyncStateChange} from '@docma-mm-core/fault/sync/fault-sync.service';
import {FaultService} from '@docma-mm-core/fault/fault.service';

export enum OverallSyncStatus {
  none = 0,
  notSynced = 1,
  syncError =2
}
export function getOverallStateByFault(f: Fault, fault: ViewFault, faultService: FaultService) {
  if (!!fault && f.uid === fault.uid) {

    const setSyncingByAttachments = fault.attachments?.some(x => x.changeState?.status !== ChangeStatusEnum.NotChanged
      || x.syncState.changes?.length > 0
      || x.syncState.status === SyncStatusEnum.Syncing);


    const faultToCheck = faultService.currentPatchMode === ActivityPatchModeEnum.MultiActivity_Group ? f : fault;

    const setSyncingByActiviites = faultToCheck.activities?.some(x => x.changeState?.status !== ChangeStatusEnum.NotChanged
      || x.syncState.changes?.length > 0
      || x.syncState.status === SyncStatusEnum.Syncing);

    if (fault.loadState?.status === LoadStatusEnum.Error || fault?.syncState?.status === SyncStatusEnum.Error
      || f.loadState?.status === LoadStatusEnum.Error || f?.syncState?.status === SyncStatusEnum.Error) {
      // console.debug('FaultStateEnum.Error - ' + fault.data.Number1?.toString() + ' | ' + fault.data.Number2?.toString() + ' | ' + fault.uid);
      return OverallSyncStatus.syncError;
    }
    else if (fault.changeState?.status !== ChangeStatusEnum.NotChanged
      || fault.syncState.changes?.length > 0
      || fault.syncState.status === SyncStatusEnum.Syncing
      || f.changeState?.status !== ChangeStatusEnum.NotChanged
      || f.syncState.changes?.length > 0
      || f.syncState.status === SyncStatusEnum.Syncing
      || setSyncingByAttachments
      || setSyncingByActiviites) {

      // console.debug('FaultStateEnum.InProgress - ' + fault.data.Number1?.toString() + ' | ' + fault.data.Number2?.toString() + ' | ' + fault.uid);
      return OverallSyncStatus.notSynced;
    } else {
      // console.debug('FaultStateEnum.None - ' + fault.data.Number1?.toString() + ' | ' + fault.data.Number2?.toString() + ' | ' + fault.uid);
      return OverallSyncStatus.none;
    }
  }
}

export function getOverallStateBySync(syncStateChanges: SyncStateChange[], fault: ViewFault) {
  const syncStateChange = syncStateChanges.find(f => f.faultUid == fault.uid);
  if (syncStateChange) {
    if (syncStateChange.faultUid === fault.uid) {

      const setSyncingByAttachments = fault.attachments?.some(x => x.changeState?.status !== ChangeStatusEnum.NotChanged
        || x.syncState.changes?.length > 0
        || x.syncState.status === SyncStatusEnum.Syncing);

      const setSyncingByActiviites = fault.activities?.some(x => x.changeState?.status !== ChangeStatusEnum.NotChanged
        || x.syncState.changes?.length > 0
        || x.syncState.status === SyncStatusEnum.Syncing);

      if (fault.loadState?.status === LoadStatusEnum.Error || syncStateChange.syncState?.status === SyncStatusEnum.Error) {
        // console.debug('setSyncState.FaultStateEnum.Error - ' + fault.data.Number1?.toString() + ' | ' + fault.data.Number2?.toString() + ' | ' + fault.uid);
        return OverallSyncStatus.syncError;
      }
      else if (fault.changeState?.status !== ChangeStatusEnum.NotChanged
        || syncStateChange.syncState?.changes?.length > 0
        || syncStateChange.syncState?.status === SyncStatusEnum.Syncing
        || setSyncingByAttachments
        || setSyncingByActiviites) {

        // console.debug('setSyncState.FaultStateEnum.InProgress - ' + fault.data.Number1?.toString() + ' | ' + fault.data.Number2?.toString() + ' | ' + fault.uid);
        return OverallSyncStatus.notSynced;
      } else {
        // console.debug('setSyncState.FaultStateEnum.None - ' + fault.data.Number1?.toString() + ' | ' + fault.data.Number2?.toString() + ' | ' + fault.uid);
        return OverallSyncStatus.notSynced;
      }
    }
  }
}
